import { City, Country } from "country-state-city";

export interface CityData {
  name?: string;
  countryCode?: string;
}

/** Option for react-select AsyncSelect (registration checkout / explorer, etc.). */
export interface CityOption {
  value: string;
  label: string;
  city: string;
  country: string;
}

let citySearchTimeout: ReturnType<typeof setTimeout> | null = null;

/** Search cities worldwide; labels are "City, Country" (same as PersonalInfoStep checkout). */
export function loadCityOptions(
  inputValue: string,
  callback: (options: readonly CityOption[]) => void,
): void {
  if (!inputValue || inputValue.trim().length === 0) {
    callback([]);
    return;
  }

  if (citySearchTimeout) {
    clearTimeout(citySearchTimeout);
  }

  citySearchTimeout = setTimeout(() => {
    try {
      const searchTerm = inputValue.trim().toLowerCase();
      const allCitiesData = City.getAllCities();
      const countryMap = new Map(
        Country.getAllCountries().map((c) => [c.isoCode, c.name]),
      );

      const filtered: CityOption[] = allCitiesData
        .filter((c: CityData) => {
          const cityName = c.name?.toLowerCase() || "";
          return cityName.includes(searchTerm);
        })
        .slice(0, 30)
        .map((c: CityData) => {
          const countryName =
            countryMap.get(c.countryCode || "") || c.countryCode || "";
          const cityName = c.name || "";
          return {
            value: cityName,
            label: `${cityName}, ${countryName}`,
            city: cityName,
            country: countryName,
          };
        });

      callback(filtered);
    } catch (e) {
      console.error("Error searching cities:", e);
      callback([]);
    }
  }, 200);
}
